import axios from 'axios'
import userService from './user.service'

export default class ApiService {
  constructor () {
    this.client = null
    this.columnis_api_url = process.env.REACT_APP_COLUMNIS_API_ENDPOINT
    this.api_url = process.env.REACT_APP_API_ENDPOINT
  }

  init (url, headers = null) {
    this.client = axios.create({
      baseURL: url,
      timeout: 30000,
      headers: headers
    })

    this.client.interceptors.response.use((response) => response, (error) => {
      if (userService.isLoggedIn() && error.response?.status === 401) {
        userService.logout()
      }
      return Promise.reject(error)
    })

    return this.client
  };

  login (user) {
    return this.init(this.columnis_api_url).post(
      'oauth',
      {
        username: user.username,
        password: user.password,
        grant_type: 'password',
        client_id: 'columnis_manager'
      })
  };

  me () {
    const headers = {
      Authorization: `Bearer ${userService.getUser().access_token}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
    return this.init(this.columnis_api_url, headers).get('me')
  }

  listAllFiles (subdirectory) {
    const headers = {
      Authorization: `Bearer ${userService.getUser().access_token}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
    return this.init(this.api_url, headers).get('listAll', { params: { subdirectoryPath: subdirectory } })
  }

  downloadFile (subdirectory, filename) {
    const headers = {
      Authorization: `Bearer ${userService.getUser().access_token}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
    const params = {
      subdirectoryPath: subdirectory,
      filename: filename
    }
    return this.init(this.api_url, headers).get('download', { params })
  }
}
